import {
  AssignModel,
  createClient,
  IdPathParameters,
  OwnerResponse,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

const client = createClient('/rest/authorization/local/token-group');

export const localTokenGroupAccessManagementPermissions = {
  ASSIGN: 'cpms.assign-local-token-group',
  UNASSIGN: 'cpms.unassign-local-token-group',
  SEARCH_OWNERS: 'cpms.search-local-token-group-owners'
};

export type AssignLocalTokenGroupRequest = AssignModel;
export type UnassignLocalTokenGroupRequest = AssignModel;

export const assignLocalTokenGroup: SaveOperation<AssignLocalTokenGroupRequest, void, string> = postRequestFactory<
  AssignLocalTokenGroupRequest,
  void
>(client, {
  pattern: '/{id}/assign',
  permissionId: localTokenGroupAccessManagementPermissions.ASSIGN
});

export const unassignLocalTokenGroup: SaveOperation<UnassignLocalTokenGroupRequest, void, string> = postRequestFactory<
  UnassignLocalTokenGroupRequest,
  void
>(client, {
  pattern: '/{id}/unassign',
  permissionId: localTokenGroupAccessManagementPermissions.UNASSIGN
});

export const getLocalTokenGroupOwners: SearchOperation<OwnerResponse, IdPathParameters<string>> = searchRequestFactory<
  OwnerResponse,
  IdPathParameters<string>
>(client, {
  pattern: '/{id}/owners',
  permissionId: localTokenGroupAccessManagementPermissions.SEARCH_OWNERS
});
